export default __webpack_public_path__ + "static/media/logo.feddbfc4.png";